import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import { useScrollNavigationContext } from '../../hooks/useScrollNavigation';
import { Item, VerticalNavigationGroupWrapper } from './components';
import { Wrapper } from './styled';
export const VerticalNavigationGroup = () => {
    const { activeId, scrollToSection, sections } = useScrollNavigationContext();
    const wrapperRef = useRef(null);
    return (_jsx(Wrapper, { ref: wrapperRef, children: sections.map(({ id, title, error, dataTestId }, index) => (_jsx(Item, { id: id, index: index, title: title, active: id === activeId, error: error, setActiveId: scrollToSection, dataTestId: dataTestId }, id))) }));
};
export { VerticalNavigationGroupWrapper };
